module.exports = __webpack_public_path__ + "static/media/download-our-top-rated-app-2x.734df5ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/download-our-top-rated-app-2x.png
// module id = 1273
// module chunks = 50